import { isEqual } from 'instantsearch.js/es/lib/utils/isEqual';
import { getStateWithoutPage } from './state';

/**
 * Returns a modified cache object for infinite hits,
 * which allows to invalidate its cache.
 *
 * For more info, see:
 * https://support.algolia.com/hc/en-us/articles/11635994384913-How-to-Refresh-React-InstantSearch-with-Infinite-Hits
 *
 * @returns {ExtendedInfiniteHitsCache} The modified cache object.
 */
// eslint-disable-next-line import/prefer-default-export
export function getInfiniteHitsCache() {
  let cachedHits = null;
  let cachedState = null;
  return {
    read: _ref => {
      let {
        state
      } = _ref;
      return isEqual(cachedState, getStateWithoutPage(state)) ? cachedHits : null;
    },
    write: _ref2 => {
      let {
        state,
        hits
      } = _ref2;
      cachedState = getStateWithoutPage(state);
      cachedHits = hits;
    },
    // We extend the cache object with this function.
    // The default object doesn't allow for invalidating.
    invalidate: () => {
      cachedHits = null;
      cachedState = null;
    }
  };
}